// frontend/src/components/layout/DriverLayout.jsx
import { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';

const API = import.meta.env.VITE_API_URL || 'http://localhost:5000/api/v1';

const DriverLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showProfile, setShowProfile] = useState(false);
  const [company, setCompany] = useState(null);

  useEffect(() => {
    fetchCompanyInfo();
  }, []);

  const fetchCompanyInfo = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/driver/dashboard`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.success) {
        setCompany(response.data.data.company);
      }
    } catch (err) {
      console.error('Company info error:', err);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Navigation items
  const navItems = [
    { path: '/driver/dashboard', icon: '📊', label: 'Хянах самбар' },
    { path: '/driver/deliveries', icon: '📦', label: 'Хүргэлтүүд' },
    { path: '/driver/inventory', icon: '🎒', label: 'Миний бараа' },
    { path: '/driver/cod', icon: '💰', label: 'COD тооцоо' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="px-4 py-3">
          <div className="flex items-center justify-between">
            {/* Logo & Company */}
            <div className="flex items-center gap-3">
               {company?.logo ? (
              <img 
                src={company.logo.startsWith('http') ? company.logo : `${API.replace('/api/v1', '')}${company.logo}`} 
                alt={company.name} 
                className="w-10 h-10 rounded-xl object-contain bg-gray-100 p-1"
              />
            ) : (
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                  <span className="text-white text-xl">🏢</span>
                </div>
              )}
              <div>
                <h1 className="text-sm font-bold text-gray-800">{company?.name || 'Компани'}</h1>
                <p className="text-xs text-gray-500">Жолоочийн панел</p>
              </div>
            </div>

            {/* Profile */}
            <div className="relative">
              <button
                onClick={() => setShowProfile(!showProfile)}
                className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition"
              >
                <span className="text-xl">👤</span>
              </button>

              {/* Profile Dropdown */}
              {showProfile && (
                <div className="absolute right-0 top-12 w-64 bg-white rounded-xl shadow-xl border border-gray-200 py-2 z-50">
                  <div className="px-4 py-3 border-b border-gray-100">
                    <p className="font-semibold text-gray-800">{user?.driver_name}</p>
                    <p className="text-sm text-gray-500">{user?.phone}</p>
                    {user?.vehicle_number && (
                      <p className="text-xs text-blue-600 mt-1">🚗 {user.vehicle_number}</p>
                    )}
                  </div>
                  {company?.phone && (
                    <a 
                      href={`tel:${company.phone}`}
                      className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-50 flex items-center gap-2"
                    >
                      <span>📞</span>
                      Компани: {company.phone}
                    </a>
                  )}
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-red-600 hover:bg-red-50 flex items-center gap-2"
                  >
                    <span>🚪</span>
                    Гарах
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pb-20">
        <Outlet />
      </main>

      {/* Bottom Navigation - Mobile Friendly */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
        <div className="flex justify-around items-center py-2">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center py-2 px-4 rounded-xl transition-all ${
                  isActive
                    ? 'text-blue-600 bg-blue-50'
                    : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                }`
              }
            >
              <span className="text-2xl mb-1">{item.icon}</span>
              <span className="text-xs font-medium">{item.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>

      {/* Click outside to close profile */}
      {showProfile && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowProfile(false)}
        />
      )}
    </div>
  );
};

export default DriverLayout;